import moment from 'moment'

export function formatPageTitle(str) {
    return (str ? (str + ' | ') : '') + 'Treker Tenant Portal'
}

export function formatNameWithAlias(name, alias) {
    if(name || alias) {
        return (name || '-') + '(' + (alias || '-') + ')'
    }else {
        return '-'
    }
}

export function formatName(name1, name2, name3) {
    const names = [name1, name2, name3].filter(el => el)

    return names.length > 0 ? names.join(' ') : ''
}

export function formatPhone(calling_code, phone) {
    let result = ''
    result += calling_code ? '(+'+ calling_code +') ' : ''
    result += phone ? phone : ''
    return result
}

export function formatDateTime(date, format='MM/DD/YYYY hh:mm A', originFormat='') {
    if(!date) return date
    return originFormat ? moment(date, originFormat).format(format) : moment(date).format(format)
}

export function firstWordToUpperCase(str) {
    return str ? (str.slice(0, 1).toUpperCase() + str.slice(1)) : ''
}


// el-table 默认排序会吧null变成0
export function sortMethod(data, prop, order, numberCols=[]) {
    if(order == 'descending') {
        if(numberCols.indexOf(prop) == -1) {
            data.sort((a, b) => {
                if(typeof(a[prop]) == 'number' && typeof(b[prop]) == 'number') {
                    if(b[prop] === undefined || b[prop] === null || b[prop] === '') {
                        return -1;
                    }else if(a[prop] === undefined || a[prop] === null || a[prop] === '') {
                        return 1;
                    }else {
                        return b[prop] - a[prop];
                    }
                }else {
                    if(b[prop] === undefined || b[prop] === null || b[prop] === '') {
                        return -1;
                    }else if(a[prop] === undefined || a[prop] === null || a[prop] === '') {
                        return 1;
                    }else {
                        return b[prop].toLowerCase() > a[prop].toLowerCase() ? 1 : (b[prop].toLowerCase() < a[prop].toLowerCase() ? -1 : 0);
                    }
                }
            });
        }else {
            data.sort((a, b) => {
                if(b[prop] === undefined || b[prop] === null || b[prop] === '') {
                    return -1;
                }else if(a[prop] === undefined || a[prop] === null || a[prop] === '') {
                    return 1;
                }else {
                    return b[prop] - a[prop];
                }
            });
        }
    }else if(order == 'ascending') {
        if(numberCols.indexOf(prop) == -1) {
            data.sort((a, b) => {
                if(typeof(a[prop]) == 'number' && typeof(b[prop]) == 'number') {
                    if(b[prop] === undefined || b[prop] === null || b[prop] === '') {
                        return 1;
                    }else if(a[prop] === undefined || a[prop] === null || a[prop] === '') {
                        return -1;
                    }else {
                        return a[prop] - b[prop];
                    }
                }else {
                    if(b[prop] === undefined || b[prop] === null || b[prop] === '') {
                        return 1;
                    }else if(a[prop] === undefined || a[prop] === null || a[prop] === '') {
                        return -1;
                    }else {
                        return b[prop].toLowerCase() < a[prop].toLowerCase() ? 1 : (b[prop].toLowerCase() > a[prop].toLowerCase() ? -1 : 0);
                    }
                }
            });
        }else {
            data.sort((a, b) => {
                if(b[prop] === undefined || b[prop] === null || b[prop] === '') {
                    return 1;
                }else if(a[prop] === undefined || a[prop] === null || a[prop] === '') {
                    return -1;
                }else {
                    return a[prop] - b[prop];
                }
            });
        }
    }
    return data;
}

export const tokenCollections = [3, 4, 5, 6, 7, 8, 9, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y']

export function generateToken(count=6) {
    let code = ''
    // 6位数字或者字母，不能出现'O', 'I', 'Z', '0', '1', '2'
    // const collections = [3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y']

    function getRandom(min, max) {
        return Math.round(Math.random() * (max - min) + min)
    } 

    for(let i = 0; i < count; i++) {
        let index = getRandom(0, 29)
        code += tokenCollections[index]
    }

    return code
}

export function delimiter(value, blocks=[3,3,4], delimiter='-') {
    if(!value) return value

    if(blocks.length >= 2) {
        const container = []
        value = value + ''
        let start = 0
        for (let i = 0; i < blocks.length; i++) {
            const count = blocks[i]
            container.push(value.slice(start, count+start))
            start += count
        }
        return container.join(delimiter)
    }else {
        return value
    }
}

export function wrapAddress(place) {
    const address_components = place.address_components;
    let street_number = "", 
        street_name = "", 
        city = "", 
        state = "", 
        country = "", 
        postal_code = "",
        postal_code_suffix = "",
        plus_code = "";

    for(let i = 0; i < address_components.length; i++) {
        const component = address_components[i];
        var type = component.types[0];
        var types = component.types;

        if(type == 'plus_code') {
            plus_code = component.long_name;
        }else if (type=='neighborhood') {
            city = component.long_name;
        }else if (type=='street_number') {
            street_number = component.short_name;
        }else if (type=='route') {
            street_name = component.long_name;
        }else if (type=='sublocality_level_1') {
            city = component.long_name;
        }else if (type=='locality') {
            city = city.length > 0 ? city : component.long_name;
        }else if (type=='administrative_area_level_1') {
            state = component.short_name;
        }else if (types.indexOf('postal_code') !== -1) {
            postal_code = component.short_name;
        }else if (type=='postal_code_suffix') {
            postal_code_suffix = component.short_name;
        }else if (type=='country') {
            country = component.short_name;
        }
    }
    const location = place.geometry.location;
    let address = {};
    address.street_number = street_number;
    address.street_name = street_name;
    address.city = place.types.indexOf('plus_code') > -1 ? (plus_code + ' ' + city) : city;
    address.state = state;
    address.postal_code = postal_code;
    address.postal_code_suffix = postal_code_suffix;
    address.country = country;
    address.latitude = formatLatlng(location.lat instanceof Function ? location.lat() : location.lat);
    address.longitude = formatLatlng(location.lng instanceof Function ? location.lng() : location.lng);
    return address;
}

export function formatAddress(addr) {
    const street_number = addr.street_number ? addr.street_number : '';
    const street_name = addr.street_name ? addr.street_name : '';
    const city = addr.city ? addr.city : '';
    const state = addr.state ? addr.state : '';
    const postal_code = addr.postal_code ? addr.postal_code : '';
    const country = addr.country ? addr.country : '';
    const arr = [street_number + (street_name ? " " + street_name : ""), city, state + (postal_code ? " " + postal_code : ""), country].filter(el => el.trim() !== '');
    return arr.length > 0 ? arr.join(', ') : ''
}

export function formatLatlng(number) {
    return Math.round(number * 100000000000000)/100000000000000;
}

export function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result
    const later = function() {
        const last = +new Date() - timestamp

        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last)
        } else {
            timeout = null
            if (!immediate) {
                result = func.apply(context, args)
                if (!timeout) context = args = null
            }
        }
    }

    return function(...args) {
        context = this
        timestamp = +new Date()
        const callNow = immediate && !timeout
        if (!timeout) timeout = setTimeout(later, wait)
        if (callNow) {
            result = func.apply(context, args)
            context = args = null
        }

        return result
    }
}

export function mileToMeter(mile) {
    return mile ? Math.round(mile * 1609 * 100) / 100 : ''
}

export function meterToMile(meter) {
    return meter ? Math.round(meter / 1609 * 100) / 100 : ''
}

export function secondToMinute(sencond) {
    return sencond ? Math.round(sencond / 60 * 100) / 100 : ''
}

export function minuteToSecond(minute) {
    return minute ? Math.round(minute * 60 * 100) / 100 : ''
}

export function nl2br(str, is_xhtml) {
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br ' + '/>' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

export function getGutter(ele1, ele2) {
    const $ele1 = document.querySelector(ele1);
    const $ele2 = document.querySelector(ele2);
    if(!$ele1 || !$ele2) {
        return;
    }
    let w1, w2;
    if(window.getComputedStyle) {
        w1 = window.getComputedStyle($ele1).getPropertyValue("width");
        w2 = window.getComputedStyle($ele2).getPropertyValue("width");
        w1 = w1.replace('px', '');
        w2 = w2.replace('px', '');
    }else {
        w1 = $ele1.clientWidth;
        w2 = $ele2.clientWidth;
    }
    const gutter = w1 - w2;
    return gutter;
}

export function formatSpeed(speed) {
    return speed ? ((speed * 2.236936).toFixed(2) + ' MPH') : ''
}

export function mphToMs(speed) {
    return speed >= 0 ? (speed / 2.236936).toFixed(2) : speed
}

export function isInjectIframe() {
    return window.frames.length !== window.parent.frames.length
}
export function isInjectToGeoTab() {
    const ancestorOrigins = window.location.ancestorOrigins
    if (ancestorOrigins.length > 0) {
        if (ancestorOrigins[0].includes('.geotab.com')) {
            return window.frames.length !== window.parent.frames.length
        } else {
            return false
        }
    } else {
        return false
    }
}

export function getALinkTarget() {
    return isInjectToGeoTab() ? '_self' : '_blank'
}